export const getButtonsTemplate = (id, isFavorite, isAvailable, price, name, brand, vendorCode, size, image, cartCount) => {
  return `<div class="product__button-container">
  ${
    isAvailable && price.current
      ? `<div class="product__button-wrap">
            <button type="button" class="product__form-button button button--f-regular button--purple js-add-cart" data-product-id="${id}" data-cart-url="/basket/add?id=${id}">
              Добавить в&nbsp;корзину
            </button>
            <button type="button" class="button button--text" data-open-target="js-fast-order-modal">
              Заказать в&nbsp;один клик
            </button>
          </div>
          <div class="product__counter-wrap">
                    <a href="/basket" class="product__cart-link button button--with-icon button--purple-hover button--f-regular">
                      В&nbsp;корзине
                      <svg width="13" height="10">
                        <use xlink:href="/img/sprite.svg?v3#icon-arrow-right"></use>
                      </svg>
                    </a>

                    <div class="cart-count cart-count--product js-modal-count" data-change-cart-url="/basket/count?id=${id}">
                      <button type="button" class="cart-count__btn cart-count__btn--minus js-modal-count-remove" aria-label="Уменьшить количество на единицу" ${
                        cartCount <= 1 ? `disabled` : ``
                      } >—</button>
                      <label class="cart-count__input-box">
                        <input type="number" class="cart-count__input js-modal-count-input js-product-count" value="${cartCount}" readonly="" disabled="">
                        <span class="visually-hidden">Количество товара</span>
                      </label>
                      <button type="button" class="cart-count__btn cart-count__btn--plus js-modal-count-plus" aria-label="Увеличить количество на единицу">+</button>
                    </div>
                  </div>`
      : ``
  }

  ${
    !isAvailable || !price.current
      ? `
  <div class="product__button-wrap">
  ${
    !isAvailable
      ? `<button class="product__form-button button button--f-regular button--stroke js-arrival-request-btn" data-id="${id}" data-product-name="${name}" data-brand="${brand}" data-image-src="${image}" data-size="${size}" data-user-mail="" type="button">Сообщить о поступлении</button>`
      : ``
  }
  ${
    !price.current
      ? `<button class="product__form-button button button--f-regular button--stroke js-price-request-open" data-id="${id}" data-product-name="${name}" data-vendor-code="${vendorCode}" data-brand="${brand}" data-image-src="${image}" data-size="${size}" data-user-mail="" type="button">Запросить цену</button>`
      : ``
  }
  </div>`
      : ``
  }
  </div>

  <button class="product__form-button-favourite add-favorite add-favorite--product js-add-favorite ${
    isFavorite ? "add-favorite--pressed" : ""
  } " data-favorite-url="/actions/ajax-product-action/add-product-favorite?productId=${id}" type="button" aria-label="${
    isFavorite ? "Удалить из избранного" : "Добавить в избранное"
  }"><svg width="25" height="22"><use xlink:href="/img/sprite.svg#heart-icon"></use></svg></button>`;
};
